<template>
  <div class="widget w-news-widget" :class="['font-size-' + fontSize, { bold: isFontBold }]">
    <c-widget-header v-if="!embeded" newsLayout printView watchlistManager :wid="wid">
      <slot name="buttons" slot="buttons" />
    </c-widget-header>

    <w-control-bar
      v-if="!embeded"
      :wid="wid"
      :maxTags="maxTags"
      :symbols="symbols"
      :topics="topics"
      :keywordsTags="keywordsTags"
      :controlFilter="controlFilter"
      :controlWatchlist="controlWatchlist"
      @filterChanged="onFilterChange"
      @keywordsInput="onKeywordsInput"
      @symbolsInput="onSymbolsInput"
      @topicsInput="onTopicsInput"
      @watchlistsChanged="onWatchlistChanged"
    />
    <w-body
      :wid="wid"
      :layout="layout"
      :maxTags="maxTags"
      :symbols="symbols"
      :keywords="keywords"
      :topics="topics"
      :isWatchlistFilterActive="isWatchlistFilterActive"
      :watchlist="watchlist"
      :watchlistItems="watchlistItems"
      :watchlistSymbols="watchlistSymbols"
      :disableSymbolLinks="disableSymbolLinks"
      :disableTopicLinks="disableTopicLinks"
      @filterChanged="onFilterChange"
      @keywordsChanged="onKeywordsInput"
      @symbolsChanged="onSymbolsInput"
      @topicsChanged="onTopicsInput"
    />
  </div>
</template>

<script>
import CWidgetHeader from '@custom/widgetContainer/CWidgetHeader';
import WControlBar from './WControlBar';
import WBody from './WBody';
import widgetCommons from '@mixins/widgetCommons';
import { API } from '@state/api';
import { getConsolidatedRic } from '@/utils/helpers';

export default {
  name: 'w-news-widget',
  mixins: [widgetCommons],
  components: {
    CWidgetHeader,
    WControlBar,
    WBody
  },
  props: {
    wid: {
      type: String,
      required: true
    },
    disableSymbolLinks: Boolean,
    disableTopicLinks: Boolean,
    embeded: {
      type: Boolean,
      default: false
    },
    externalSymbol: {
      type: Array
    }
  },
  data() {
    return {
      maxTags: 5,
      watchlistSymbols: []
    };
  },
  watch: {
    watchlistItems: {
      immediate: true,
      handler(items) {
        if (!items.length) this.watchlistSymbols = [];
        else {
          const constituentsReqs = [];
          const rics = new Set();
          items.forEach(item => {
            if (/^(0#)?\./.test(item)) {
              const currentRic = getConsolidatedRic(item.replace('0#', ''));
              constituentsReqs.push(API.Rest.get('/index/constituents?ric=' + currentRic + '&fids=q.RIC'));
            } else rics.add(item);
          });
          Promise.all(constituentsReqs).then(responses => {
            responses.forEach(response => {
              if (response.data && response.data.data) response.data.data.forEach(entity => rics.add(entity['q.RIC']));
            });
            this.watchlistSymbols = [...rics.values()];
          });
        }
      }
    }
  },
  computed: {
    layout() {
      return this.$store.state.widget[this.wid].layout;
    },
    symbols() {
      if (this.embeded) return this.externalSymbol;
      else return this.isWatchlistFilterActive ? this.watchlistSymbols : this.$store.state.widget[this.wid].symbols;
    },
    keywords() {
      return this.$store.state.widget[this.wid].keywords;
    },
    keywordsTags() {
      return this.$store.state.widget[this.wid].keywords.map(keyword => ({ text: keyword }));
    },
    topics() {
      return this.$store.state.widget[this.wid].topics;
    },
    controlFilter() {
      return this.$store.state.widget[this.wid].filter;
    },
    controlWatchlist() {
      const watchlist = this.$store.state.widget[this.wid].watchlist;
      return !watchlist || this.watchlists.find(w => w.id === watchlist) ? watchlist : '';
    },
    isWatchlistFilterActive() {
      return Boolean(this.$store.state.widget[this.wid].filter && this.watchlist);
    },
    watchlist() {
      return this.$store.state.widget[this.wid].watchlist;
    },
    watchlists() {
      return this.$store.getters['watchlists/watchlistsSorted'];
    },
    watchlistItems() {
      if (!this.watchlist) return [];
      return this.$store.getters['watchlists/getWatchlist'](this.watchlist).items;
    }
  },
  methods: {
    // ControlBar
    onFilterChange(isFilter) {
      this.$store.commit(`widget/${this.wid}/FILTER_CHANGED`, isFilter);
    },
    onKeywordsInput(keywords) {
      this.$store.commit(`widget/${this.wid}/KEYWORDS_CHANGED`, keywords.map(keyword => keyword.text));
    },
    onSymbolsInput(symbols) {
      this.$store.commit(`widget/${this.wid}/SYMBOLS_CHANGED`, symbols);
      if (symbols.length) {
        this.sendLinkUpdate(symbols[symbols.length - 1]);
      }
    },
    onTopicsInput(newTopics) {
      if (newTopics.length > 1 && newTopics[0].text === 'ALL') {
        newTopics = newTopics.slice(1, newTopics.length);
      } else if (newTopics.length === 0 || (newTopics.length > 0 && newTopics[newTopics.length - 1].text === 'ALL')) {
        newTopics = [{ text: 'ALL' }];
      }

      this.$store.commit(`widget/${this.wid}/TOPICS_CHANGED`, newTopics.map(topic => topic.text));
    },
    onWatchlistChanged(watchlist) {
      this.$store.commit(`widget/${this.wid}/WATCHLIST_CHANGED`, watchlist);
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/vendor/splitpanes';
@import '~@/styles/widgets/news-widget';
</style>
